export class EnvService {

  public api = "/api";
  public production = true;
  public mode: 'Production';

  constructor() {
  }

}

export const EnvServiceFactory = () => {
  const env = new EnvService();
  const browserWindow = window || {};
  const browserWindowEnv = browserWindow["__env"] || {};

  for (const key in browserWindowEnv) {
    if (browserWindowEnv.hasOwnProperty(key)) {
      env[key] = window["__env"][key];
    }
  }

  return env;
};

export const EnvServiceProvider = {
  provide: EnvService,
  useFactory: EnvServiceFactory,
  deps: [],
};



// WEBPACK FOOTER //
// ./src/environments/environment.factory.ts